import React from 'react';
import { motion } from 'framer-motion';
import { track } from '../../lib/analytics';
import { WhatsAppGlyph } from './CtaButtons';
import { openSevaPicker } from './SevaPicker';

const FloatingWhatsApp = () => {
  const onClick = () => {
    track('cta_whatsapp_open_picker', 'floating');
    openSevaPicker('floating');
  };
  return (
    <motion.button
      data-testid="floating-whatsapp"
      onClick={onClick}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: 'spring', stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-[0_12px_30px_-6px_rgba(37,211,102,0.6)]"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-whatsapp opacity-30" />
      <WhatsAppGlyph className="relative h-7 w-7" />
    </motion.button>
  );
};

export default FloatingWhatsApp;
